var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"vue-custom-checkbox",class:{ checked: _vm.content, disabled: _vm.disabled },on:{"click":_vm.toggle}},[_c('div',{ref:"check",staticClass:"dummy-checkbox",class:{ checked: _vm.content, disabled: _vm.disabled }}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }